import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import DropdownElement from '../../../../Components/UiComponents/DropdownElement';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { addInFieldConfig, addNewRdsField } from '../../../../Services/customerServices';
import { updateToolTip } from '../../../../Services/tooltipService';
import '../../../../App.css'
import { InputNumber } from 'primereact/inputnumber';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import DataTable from '../../../../Components/UiComponents/DataTable';
import Loader from "../../../../Components/UiComponents/Loader";

const AddNewAssessmentPopup = ({ visible, groupsDropdown, customer, dropdownHeaders, controlPannelRDSFieldsHeaders, fieldHeader, onClosePopup, position }) => {
  const [selectedOption, setSelectedOption] = useState([]);
  const toastRef = useRef();

  const options = [
    { name: "dropdown", value: "dropdown" },
    { name: "Percentage", value: "Percentage" },
    { name: "Text box", value: "Text box" },
    { name: "Numerical", value: "Numerical" },
    { name: "Dropdown (Multi-Select)", value: "dropdown multi-select"}
  ];

  const [fieldData, setFieldData] = useState({});
  const [loading, setLoading] = useState(false);

  const [option, setOption] = useState([
    { option_id: '', options: '', id: '', text: '', status: 'active' }
  ]);

  function generateRandomID() {
    const hexChars = '0123456789abcdef';
    let result = '';
    for (let i = 0; i < 24; i++) {
      result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
    }
    return result;
  }

  const handleAddOption = () => {
    const newRow = {
      option_id: generateRandomID(),
      options: '',
      id: '',
      text: '',
      status: 'active'
    };
    setOption([...option, newRow]);
  };

  const onTextChange = (index, field) => (e) => {
    const newRows = [...option];
    if (field === 'id') {
      newRows[index][field] = e.value;
    }
    else {
      newRows[index][field] = e.target.value;
    }
    setOption(newRows);
  };



  const checkForDuplicate = () => {
    const option_name = customer.rds_data.filter((assessment) => assessment.option_name === fieldData.option_name)
    if (option_name.length === 0) {
      return true
    } else {
      return false
    }
  }

  const saveNewAssessment = async () => {
    try {
      setLoading(true)
      if (validate()) {
        if (checkForDuplicate()) {

          let fieldUpdate = fieldData
          fieldUpdate.option_choice = option
          const customerResponse = await addNewRdsField(customer._id, fieldUpdate)
          const fieldConfigResponse = await addInFieldConfig(customer._id, fieldUpdate)

          if (customer?.tooltips?.client?.rds?.criteria) {
            var last_data = Object.keys(customer?.tooltips?.client?.rds?.criteria).pop();
            var field_index = customer.tooltips.client.rds.criteria[last_data].index;
            var newFields = {
              "index": field_index + 1,
              "field_name": fieldUpdate.field_name,
              "ESG_field_name": fieldUpdate.display_name,
              "text": 'Information about the field will be displayed here.',
              "status": false
            }
            customer.tooltips.client.rds.criteria[fieldUpdate.option_name] = newFields;
            const newTooltipData = customer.tooltips
            const tooltipResponse = await updateToolTip(customer._id, newTooltipData)


            if (tooltipResponse && tooltipResponse.status === 200) {
              toastRef.current.showToast({
                type: 'success',
                message: 'Tooltip Info Updated Successfully'
              });

            } else {
              toastRef.current.showToast({
                type: 'error',
                message: 'Error in Tooltip updating'
              });
              setLoading(false)
            }
          }
          if (customerResponse && customerResponse.data.success) {
            toastRef.current.showToast({
              type: 'success',
              message: 'Dropdown Customer Info Updated Successfully'
            });


          } else {
            toastRef.current.showToast({
              type: 'error',
              message: 'Error in Customer updating'
            });
            setLoading(false)
          }
          if (fieldConfigResponse && fieldConfigResponse.data.success) {
            toastRef.current.showToast({
              type: 'success',
              message: 'Field Config Info Updated Successfully'
            });

            setTimeout(() => {
              onClosePopup()
            }, 1000)
            setLoading(false)
          } else {
            toastRef.current.showToast({
              type: 'error',
              message: 'Error in Field Config updating'
            });
            setLoading(false)

          }

        } else {
          toastRef.current.showToast({
            type: 'error',
            message: 'Duplicate Field'
          });
        }
        setLoading(false)
      } else {
        toastRef.current.showToast({
          type: 'error',
          message: 'Fields are required / invalid'
        });
        setLoading(false)
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'Failed to fetch customer fields'
      });
    }
  }

  const handleFieldData = (name, value) => {
    setErrors({
      ...errors,
      [name]: value ? '' : errors[name]
    });
    if (value === "Text box") {
      setFieldData((prevState) => ({
        ...prevState,
        ['option_choice']: [{ option_id: 'option1', options: '', id: '', text: '', status: 'active' }],
      }));
    } else if (value != "Text box") {
      setFieldData((prevState) => ({
        ...prevState,
        ['option_choice']: option,
      }));
    }
    setFieldData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }
  // const onChoiceChange = (e) => {
  //   const updatedOptions = e.checked
  //     ? [...selectedOption, e.value]
  //     : selectedOption.filter(choice => choice._id !== e.value._id);

  //   setSelectedOption(updatedOptions);
  // };
  const validateInput = (event) => {
    const pattern = /^[a-zA-Z0-9_]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9_]/g, '');
    }
  };

  const [errors, setErrors] = useState({});
  const validate = () => {
    let tempErrors = {};
    if (!fieldData.option_name) tempErrors.option_name = "Stakeholder Assessment Fields is required";
    if (!fieldData.field_name) tempErrors.field_name = "Field Name is required";
    if (!fieldData.display_name) tempErrors.display_name = "Display Name is required";
    if (!fieldData.option_status) tempErrors.option_status = "Status is required";
    if (!fieldData.flag_status) tempErrors.flag_status = "Attachment is required";
    if (!fieldData.group) tempErrors.group = "Group is required";
    if (!fieldData.field_type) tempErrors.field_type = "Type is required";


    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const renderInput = {
    "Stakeholder Assessment Fields": (header, index) => (
      <div key={index} className="form-group row align-items-center mb-0 mt-0">
        <div className="col-md-4 pl-0">
          <label className="form-label text-left">
            {header.display_name}
          </label>
        </div>
        <div className="col pr-0">
          <InputTextElementElement
            name="option_name"
            onChange={(e) => handleFieldData(e.target.name, e.target.value)}
            className="w-full"
            onInput={(e) => validateInput(e)}
            pattern="/^[a-zA-Z0-9_]*$/"
          />
          {errors.option_name && <span className="text-red-500 color-red">{errors.option_name}</span>}
        </div>

      </div>
    ),
    "Field Name": (header, index) => (
      <div key={index} className="form-group row align-items-center mb-0 mt-0">
        <div className="col-md-4 pl-0">
          <label className="form-label text-left">
            {header.display_name}
          </label>
        </div>
        <div className="col pr-0">
          <InputTextElementElement
            name="field_name"
            onChange={(e) => handleFieldData(e.target.name, e.target.value)}
            className="w-full"
          />
          {errors.field_name && <span className="text-red-500 color-red">{errors.field_name}</span>}
        </div>

      </div>
    ),
    "Display Name": (header, index) => (
      <div key={index} className="form-group row align-items-center mb-0 mt-0">
        <div className="col-md-4 pl-0">
          <label className="form-label text-left">
            {header.display_name}
          </label>
        </div>
        <div className="col pr-0">
          <InputTextElementElement
            name="display_name"
            onChange={(e) => handleFieldData(e.target.name, e.target.value)}
            className="w-full"
          />
          {errors.display_name && <span className="text-red-500 color-red">{errors.display_name}</span>}
        </div>

      </div>
    ),
    Status: (header, index) => (
      <div key={index} className="form-group row align-items-center mb-0 mt-0">
        <div className="col-md-4 pl-0">
          <label className="form-label text-left">
            {header.display_name}
          </label>
        </div>
        <div className="col pr-0">
          <RadioElement
            options={[
              { key: "true", name: "Yes" },
              { key: "false", name: "No" },
            ]}
            value={fieldData.option_status}
            onChangeRadio={(value) => handleFieldData('option_status', value)}
            className="radio-group-class" // Add any additional classes if necessary
            disabled={false} // Adjust the disabled prop as needed
          />
          {errors.option_status && <span className="text-red-500 color-red">{errors.option_status}</span>}
        </div>
      </div>
    ),
    Attachment: (header, index) => (
      <div key={index} className="form-group row align-items-center mb-0 mt-0">
        <div className="col-md-4 pl-0">
          <label className="form-label text-left">
            {header.display_name}
          </label>
        </div>
        <div className="col pr-0">
          <RadioElement
            options={[
              { key: "true", name: "Yes" },
              { key: "false", name: "No" },
            ]}
            value={fieldData.flag_status}
            onChangeRadio={(value) => handleFieldData('flag_status', value)}
            className="radio-group-class" // Add any additional classes if necessary
            disabled={false} // Adjust the disabled prop as needed
          />
          {errors.flag_status && <span className="text-red-500 color-red">{errors.flag_status}</span>}
        </div>
      </div>
    ),
    Group: (header, index) => (
      <div key={index} className="form-group row align-items-center mt-0 mb-0">
        <div className="col-md-4 text-left pl-0">
          <label className="form-label text-left">
            {
              header.display_name
            }
          </label>
        </div>
        <div className="col pr-0">
          <DropdownElement
            value={fieldData.group}
            onChange={(e) => handleFieldData("group", e.target.value)}
            options={(groupsDropdown != undefined && groupsDropdown.length > 0) ? groupsDropdown : []}
            optionLabel="name"
            placeholder="-- Please select --"
            className="w-full"
          />
          {errors.group && <span className="text-red-500 color-red">{errors.group}</span>}
        </div>
      </div>
    ),
    Type: (header, index) => (
      <div key={index} className="form-group row align-items-center mt-0 mb-0">
        <div className="col-md-4 text-left pl-0">
          <label className="form-label text-left">
            {
              header.display_name
            }
          </label>
        </div>
        <div className="col pr-0">
          <DropdownElement
            value={fieldData.field_type}
            options={(options != undefined && options.length > 0) ? options : []}
            onChange={(e) => handleFieldData("field_type", e.target.value)}
            optionLabel="name"
            placeholder="-- Please select --"
            className="w-full"
          />
          {errors.field_type && <span className="text-red-500 color-red">{errors.field_type}</span>}
        </div>
      </div>
    ),
    Weightage: (header, index) => (
      <div key={index} className="form-group row align-items-center mb-0 mt-0">
        <div className="col-md-4 pl-0">
          <label className="form-label text-left">
            {header.display_name}
          </label>
        </div>
        <div className="col pr-0">
          <InputTextElementElement
            value={fieldData.weightage}
            name="weightage"
            onChange={(e) => handleFieldData(e.target.name, e.target.value)}
            className="w-full"
          />
        </div>
      </div>
    ),
  };
  // Add options

  const handleDeleteOption = (data) => {
    const updatedOptions = option.filter(row => row.option_id != data.option_id);
    setOption(updatedOptions);
    setSelectedOption([]);
  };

  const labelEditor = (rowData, index) => {
    if (rowData.rowIndex == undefined) {
      rowData['rowIndex'] = 0
    }
    return (
      <InputTextElementElement
        value={rowData.options}
        onChange={onTextChange(rowData.rowIndex, 'options')}
        placeholder="Value"
      />
    );
  };

  const textEditor = (rowData, index) => {
    if (rowData.rowIndex == undefined) {
      rowData['rowIndex'] = 0
    }
    return (
      <InputTextElementElement
        value={rowData.text}
        onChange={onTextChange(rowData.rowIndex, 'text')}
        placeholder="Text"
      />
    );
  };

  const scoreEditor = (rowData, index) => {
    if (rowData.rowIndex == undefined) {
      rowData['rowIndex'] = 0
    }
    return (
      <InputNumber
        value={rowData.id}
        onChange={onTextChange(rowData.rowIndex, 'id')}
        placeholder="Score"
        mode="decimal"
        aria-describedby="username-help"
        showButtons
        className="d-flex"
      />
    );

  };

  const actionBodyTemplate = (rowData) => {
    return (
      <i
        className="pi pi-trash"
        onClick={() => handleDeleteOption(rowData)}
      />
    );
  };

  const columns = [
    { field: "options", header: "Dropdown Option", editor: labelEditor, body: labelEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    { field: "id", header: "Score", editor: scoreEditor, body: scoreEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    { field: "text", header: "Text", editor: textEditor, body: textEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    { field: "text1", header: "", body: actionBodyTemplate, headerClassName: "header-datatable", className: 'row-datatable' }
  ]

  const rowClick = async (data) => {
    console.log("data", data)
  };

  const renderDialogContent = () => (
    <div className="new-field">
      <form onSubmit={saveNewAssessment}>
        {fieldHeader.map((header, index) => (
          header.header_name !== "Weightage" ? renderInput[header.header_name] && renderInput[header.header_name](header, index) : null
        ))}
        {
          fieldData.field_type != "Text box" &&
          <div className='dropdown-table-layout-adjust'>
            {fieldHeader.map((header, index) => (
              header.header_name === "Weightage" ? (
                renderInput[header.header_name] && renderInput[header.header_name](header, index)
              ) : null
            ))}
          </div>
        }
        {
          fieldData.field_type != "Text box" &&
          <>

            {dropdownHeaders.map((header, index) => (
              <React.Fragment key={header.option_name || index}>
                {
                  header.header_name === "Options" &&
                  <div className="form-group row align-items-center mb-0">
                    <div className="col-md-4 pl-0 pt-17">
                      <p className="label-text">
                        {header.header_name === "Options" ? (
                          <p>{header.display_name}</p>
                        ) : null}
                      </p>
                    </div>
                    <div className="col pr-0 d-flex justify-end">
                      <ButtonElement className="new-option-button" type="button" icon="pi pi-plus" label=" New Option" onClick={handleAddOption} />
                    </div>
                  </div>
                }
              </React.Fragment>
            ))}
            <div>
              <DataTable
                value={option}
                columns={columns}
                editMode="cell"
                dataKey="option_id"
                isNewField={true}
                rowClick={rowClick}
              />
            </div>
          </>
        }

      </form>
    </div>
    // <div className="group-field-display">
    //   {fieldHeader.map(header => (
    //     header.header_name !== "Weightage" ? renderInput[header.header_name] && renderInput[header.header_name](header) : null
    //   ))}
    //   <>
    //     {["dropdown", "Percentage", "Numerical"].includes(fieldData.field_type) && (
    //       <div className='dropdown-table-layout-adjust'>
    //         {fieldHeader.map(header => (
    //           header.header_name === "Weightage" ? (
    //             renderInput[header.header_name] && renderInput[header.header_name](header)
    //           ) : null
    //         ))}
    //         <div className="group-option-field">
    //           {dropdownHeaders.map(header => (
    //             <React.Fragment key={header._id}>
    //               {header.header_name === "Options" ? (
    //                 <p>{header.display_name}</p>
    //               ) : null}
    //             </React.Fragment>
    //           ))}
    //           <div className='flex justify-end'>
    //             <i className="pi pi-trash mr-2" onClick={handleDeleteOption} />
    //             <i className="pi pi-plus-circle ml-2 mr-2" onClick={handleAddOption} />
    //           </div>
    //         </div>
    //         <table className="group-datatable">
    //           <thead className="group-table-header">
    //             <tr>
    //               <th className='w-125'></th>
    //               {dropdownHeaders.map(header =>
    //                 header.header_name !== "Options" ? (
    //                   <th key={header._id} className="w-291">{header.display_name}</th>
    //                 ) : null
    //               )}
    //             </tr>
    //           </thead>
    //           <tbody className="group-table-row dropdown-table">
    //             {option.map((row, index) => (
    //               <tr key={row.option_id}>
    //                 <td className='w-125'>
    //                   <Checkbox
    //                     inputId={row.option_id}
    //                     name="checkbox"
    //                     onChange={(e) => onCheckboxChange(e, row)}
    //                     checked={selectedOption.includes(row.option_id)}
    //                   />
    //                 </td>
    //                 <td className="w-291">
    //                   <div className='flex justify-center'>
    //                     <InputTextElementElement
    //                       className="dropdown-field-handle"
    //                       value={row.options}
    //                       placeholder="Value"
    //                       onChange={onTextChange(index, 'options')}
    //                     />
    //                   </div>
    //                 </td>
    //                 <td className="w-291">
    //                   <div id="score" className='flex justify-center align-center' style={{ padding: "8px" }}>
    //                     <InputNumber
    //                       className="dropdown-field-handle"
    //                       value={row.id}
    //                       placeholder="Score"
    //                       onChange={onTextChange(index, 'id')}
    //                       mode="decimal"
    //                       style={{ height: "35px", fontSize: "12px" }}
    //                       incrementButtonClassName="custom-increment-button"
    //                       decrementButtonClassName="custom-decrement-button"
    //                       showButtons />
    //                   </div>
    //                 </td>
    //                 <td className="w-291">
    //                   <div className='flex justify-center'>
    //                     <InputTextElementElement
    //                       className="dropdown-field-handle"
    //                       value={row.text}
    //                       placeholder="text"
    //                       onChange={onTextChange(index, 'text')}
    //                     />
    //                   </div>
    //                   {/* <DropdownElement
    //                   options={[
    //                     { name: "Active", value: "active" },
    //                     { name: "InActive", value: "inactive" },
    //                   ]}
    //                   optionLabel="name"
    //                   className="dropdown-field-handle"
    //                   value={row.status}
    //                   onChange={onDropdownChange(index)}
    //                 /> */}
    //                 </td>
    //               </tr>
    //             ))}
    //             {/* <tr >
    //               <td>
    //                 <Checkbox
    //                   onChange={onChoiceChange}
    //                 />
    //               </td>
    //               <td>
    //                 <InputTextElementElement
    //                   className="dropdown-field-handle"
    //                 />
    //               </td>
    //               <td>
    //                 <InputTextElementElement
    //                   className="dropdown-field-handle"
    //                 />
    //               </td>
    //               <td>
    //                 <DropdownElement
    //                   options={[
    //                     { name: "Active", value: "active" },
    //                     { name: "InActive", value: "inactive" },
    //                   ]}
    //                   optionLabel="name"
    //                   className="dropdown-field-handle"
    //                 />
    //               </td>
    //             </tr> */}
    //           </tbody>
    //         </table>
    //       </div>
    //     )}
    //   </>

    //   <div className="group-popup-button">
    //     <ButtonElement label="Save" className="popup-button" onClick={saveNewAssessment} />
    //     <ButtonElement label="Return to default" className="popup-button" />
    //   </div>
    // </div>
  );

  const renderFooter = (a) => {
    return (
      <div className="cancel-footer">
        <div className='align-center justify-end pb-0'>
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={onClosePopup} />
          <ButtonElement type="submit" label="Save" className="save-button" onClick={saveNewAssessment} />
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <Dialog
        header={controlPannelRDSFieldsHeaders.filter(header => header.header_name === "Stakeholder Assessment Fields").display_name || "New Stakeholder Assessment Fields"}
        visible={visible}
        position={position}
        className='width-50vw'
        onHide={onClosePopup}
        footer={renderFooter()}
        draggable={false}
      >
        {renderDialogContent()}
      </Dialog>
    </>
  );
};

export default AddNewAssessmentPopup;
